import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { Text } from "@repo/skapa";
import { Icon, chevronDownSmallIcon, chevronUpSmallIcon } from "@repo/skapa";
import { type ReactNode, useState } from "react";

import {
  EXTRA_PADDING_HEIGHT,
  NAME_COL_WIDTH,
  TASK_BLOCK_HEIGHT,
} from "./constants";

const CategoryRowContainer = styled.div`
  cursor: pointer;
  position: relative;
  background-color: ${LightMode.colourStaticWhite};
  font-weight: 600;
  border-bottom: 2px solid ${LightMode.colourStaticBlack};
`;

const CategoryRowNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${TASK_BLOCK_HEIGHT + EXTRA_PADDING_HEIGHT}px;
  position: sticky;
  left: 0;
  padding: 0 5px;
  z-index: 3;
  width: ${NAME_COL_WIDTH}px;
  white-space: nowrap;
  background-color: ${LightMode.colourStaticWhite};
`;

const GreyContainer = styled.div`
  background-color: rgb(242, 242, 242);
`;

interface Props {
  title: string;
  children: ReactNode;
}
export const CategoryRow = ({ title, children }: Props) => {
  const [hidden, setHidden] = useState(false);

  return (
    <GreyContainer>
      <CategoryRowContainer>
        <CategoryRowNameContainer onClick={() => setHidden(!hidden)}>
          <Text textStyle="Body.S" overflowHidden title={title}>
            {title}
          </Text>
          <div>
            <Icon paths={hidden ? chevronUpSmallIcon : chevronDownSmallIcon} />
          </div>
        </CategoryRowNameContainer>
      </CategoryRowContainer>
      {hidden ? null : children}
    </GreyContainer>
  );
};
